import { Box, Center, Overlay, Paper } from '@mantine/core';
import classes from './SeasonEvents.module.css';
import { useNowPricing } from '../SeasonNowPricing/NowPricing.hooks';
import { BNButton } from '../../components/Button/Button';
import CheckIcon from '../../components/icons/Check';
import { SeasonEventsHeader } from './SeasonEvents.Header';
import { SeasonEventsList } from './SeasonEvents.List';

export function SeasonEvents() {
  const { submit, ruleForm } = useNowPricing();
  return (
    <Paper className={classes.seasonEventsWrapper} pos="relative">
      {/* Note: isDirty returns true but getDirty is empty. Deep ref issue in the tree. This resolves it  */}
      {Object.keys(ruleForm.getDirty()).length > 0 && (
        <Box>
          <Overlay bg="var(--colors-overlay)" center>
            <Center>
              <BNButton className={classes.subtleButton} variant="subtle" bg="var(--colors-paper)" leftSection={<CheckIcon />} size="sm" onClick={() => submit()}>
                Apply Filters
              </BNButton>
            </Center>
          </Overlay>
        </Box>
      )}
      <SeasonEventsHeader />
      <SeasonEventsList />
    </Paper>
  );
}
